export { default as ArticleHeader } from './article-header/ArticleHeader'
export { default as ArticleIntro } from './article-intro/ArticleIntro'
export { default as ArticleBody } from './article-body/ArticleBody'
export { default as ArticleValve } from './article-valve/ArticleValve'
export { default as ArticleFooter } from './article-footer/ArticleFooter'
